import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import Manage from './AuthenticationsPageParts/Manage'
import Overview from './AuthenticationsPageParts/Overview'
import Providers from './AuthenticationsPageParts/Providers'
import Ratings from './AuthenticationsPageParts/Ratings'
import SimilarInfluencers from './AuthenticationsPageParts/SimilarInfluencers'
import SocialPosts from './AuthenticationsPageParts/SocialPosts'
import Statistics from './AuthenticationsPageParts/Statistics'
import Collaborations from './AuthenticationsPageParts/Collaborations'
import CollaborationTimeline from './AuthenticationsPageParts/CollaborationTimeline'
import { InfluencerContext } from '../../../contexts/InfluencerContext'
import { SharedCampaignContext } from '../../../contexts/Advertiser/SharedCampaignContext'
import NewAuthenticationModal from '../../../components/ProjectManager/Influencers/NewAuthenticationModal'

export default observer(function AuthenticationsPage() {
  const location = useLocation()
  const influencerContext = useContext(InfluencerContext)
  const sharedCampaignContext = useContext(SharedCampaignContext)

  // Determine if we're in Advertiser shared-campaign context or regular Project Manager context
  const isAdvertiserContext = !!sharedCampaignContext?.campaignState
  const isProjectManagerContext = !!influencerContext?.influencer

  // Use the appropriate context
  const context = isAdvertiserContext ? sharedCampaignContext : influencerContext
  const { addAuthenticationModalOpen, setAddAuthenticationModalOpen, addAuthenticationModalMode, addAuthenticationModalProvider, influencer, authentications, getAuthentications } = influencerContext || {}

  return (
    <div className="bg-rb-grey dark:bg-rb-dark-mode-background">
      {!location.pathname.includes('ratings') && <Providers isAdvertiserContext={isAdvertiserContext} />}
      <div className="pl-4 pt-4 pr-2 dark:bg-rb-dark-mode-background">
        <Routes>
          <Route path="overview" element={<Overview />} />
          <Route path="statistics" element={<Statistics />} />
          <Route path="social_posts" element={<SocialPosts />} />
          <Route path="collaborations" element={<Collaborations />} />
          <Route path="similar_influencers" element={<SimilarInfluencers />} />
          <Route path="ratings" element={<Ratings />} />
          <Route path="manage" element={<Manage />} />
        </Routes>
      </div>
      {isProjectManagerContext && <NewAuthenticationModal isOpen={addAuthenticationModalOpen} setIsOpen={setAddAuthenticationModalOpen} infId={influencer?.id} authentications={authentications} initialMode={addAuthenticationModalMode} initialProvider={addAuthenticationModalProvider} onAuthenticationsChanged={getAuthentications} />}
    </div>
  )
})